// Func = limiting Scope for this file
(function () {
  setTimeout(() => {
    $("#header").css("opacity", "1");
    $("#header .header-logo").css("display", "block");
    $(".top-content").css("opacity", "1");
    $(".intro-content-home").css("opacity", "1");
    $(".sub-menu").css("opacity", "1");
    $(".amenities__content").css("opacity", "1");
    $(".body__content").css("opacity", "1");
    $(".footer").css("opacity", "1");
    $(".primary-nav-booking").css("opacity", "1");

    $("#primary-nav ul li:last-of-type").after($(".primary-nav-booking"));

    $("#primary-nav ul.submenu").find($("a.header-logo")).remove();
    $("#primary-nav ul.submenu").find($(".primary-nav-booking")).remove();

    if (window.innerWidth > 1000) {
      $("#secondary-nav ul li:nth-child(4)").after(
        '<li class="secondary-nav-logo"><a href="' +
          site_url +
          '"><span class="hidden">Ocean Edge Resort & Golf Club</span></a></li>'
      );
    }
  }, 200);

  $(".fancybox").fancybox({
    padding: 0,
    scrolling: "auto",
    nextEffect: "fade",
    prevEffect: "fade",
    helpers: {
      title: {
        type: "inside",
      },
    },
  });

  function resizeWindow() {
    setTimeout(function () {
      // equalize();
      if ($(document).width() < 1024) {
        $(".header-logo").appendTo("#header .secondary_header");
        $("#primary-nav li").click(function () {
          window.location = $(this).find("a").attr("href");
        });
      } else {
        //$('#primary-nav ul li.primary-nav-14').after($('.header-logo'));
        $("#primary-nav").find($("a.header-logo")).remove();
      }
    }, 500);
  }
  function scrollDown() {
    let top = $(document).scrollTop();
    if ($("#content").hasClass("noheaderimage")) {
      if (!$("#header").hasClass("scroll-down")) {
        $("#header").addClass("scroll-down");
      }
    } else {
      if (top > 80) {
        if (!$("#header").hasClass("scroll-down")) {
          $("#header").addClass("scroll-down");
        }
      } else {
        if ($("#header").hasClass("scroll-down")) {
          $("#header").removeClass("scroll-down");
        }
      }
      if (top > 475) {
        if (!$(".sub-menu").hasClass("scroll-down")) {
          $(".sub-menu").addClass("scroll-down");
        }
      } else {
        if ($(".sub-menu").hasClass("scroll-down")) {
          $(".sub-menu").removeClass("scroll-down");
        }
      }
    }
  }

  $(document).ready(function () {
    //Call function with browser is resized.
    $(window).resize(function (event) {
      resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
      scrollDown();
    });
    scrollDown();

    //check iframes in page frost bar
    if ($(".frost-bar").length > 0) {
      setTimeout(function () {
        $(".frost-bar .intro-content-home")
          .find("iframe")
          .each(function () {
            $(this).css("max-height", "200px");
          });
      }, 1000);
    }

    $(".arrow-home").click(function (event) {
      $("body, html").animate(
        {
          scrollTop: $(".top-content").height() - 73,
        },
        300,
        "easeOutExpo"
      );
    });

    if ($("body#gallery").length > 0 || $("body#map-category").length > 0) {
      $("#header").addClass("hover__effect");
    }

    // *only* if we have anchor on the url
    if (window.location.hash) {
      var offset = -10;
      // smooth scroll to the anchor id
      $("html, body").animate(
        {
          scrollTop: $(window.location.hash).offset().top + offset + "px",
        },
        1000,
        "swing"
      );
      if (window.location.hash.indexOf("#three__quads--") > -1) {
        setTimeout(() => {
          $(window.location.hash + " a").trigger("click");
        }, 1100);
      }
      if (window.location.hash.indexOf("#image__copy--") > -1) {
        setTimeout(() => {
          $(window.location.hash + " a").trigger("click");
        }, 1100);
      }
    }

    $(".intro-content-home a").click(function (e) {
      if ($(this).attr("href").indexOf("#") > -1) {
        if ($(this).attr("href").indexOf("portal.oceanedge.com") < 0) {
          e.preventDefault();
          let newTarget = $(this).attr("href");

          $("html, body").animate(
            {
              scrollTop: $(newTarget).offset().top - 200 + "px",
            },
            1000,
            "swing"
          );
        }
      }
    });

    //Add value in email-signup Interest field
    $("#footer .top__footer--interest li").click(function () {
      let elements_option = document.querySelectorAll(
        "#email-interest .option:checked"
      );
      let selected_items = [];
      for (var i = 0; i < elements_option.length; i++) {
        selected_items.push(elements_option[i].value);
      }
      $("#email-signup_INTEREST").val(selected_items);
    });
    $("#footer #email-signup [role=group]").appendTo(
      "#footer .top__footer--policies"
    );
    $("#footer #email-signup button").insertAfter(
      ".top__footer--policies [role=group]"
    );
    $("#footer .top__footer--policies button").click(function () {
      if ($("#email-signup_FNAME").val() == "") {
        $("#email-signup_FNAME").css("border-bottom", "1px solid red");
        //return false;
      }
      if ($("#email-signup_email_address").val() == "") {
        $("#email-signup_email_address").css("border-bottom", "1px solid red");
        //return false;
      }
      if ($("#email-signup_state").val() == "") {
        $(".nice-select").css("border-bottom", "1px solid red");
        //return false;
      }
      if (!$("#privacy_termsemail-signup").is(":checked")) {
        $("label[for=privacy_termsemail-signup]").css("color", "red");
        $("label[for=yes-signup-formemail-signup]").css("color", "red");
        //return false;
      } else {
        $("#email-signup_FNAME").removeAttr("style");
        $("#email-signup_email_address").removeAttr("style");
        $(".nice-select").removeAttr("style");

        $(".top__footer--interest h4").css("color", "#333");
        $('label[for="privacy_termsemail-signup"]').css("color", "#333");
        $('label[for="yes-signup-formemail-signup"]').css("color", "#333");
        $("#footer #email-signup").submit();
        setTimeout(() => {
          $(".top__footer--interest").css("opacity", "0");
          $(".top__footer--interest").css("height", "0");
          $(".top__footer--policies").css("opacity", "0");
          $(".top__footer--policies").css("height", "0");
        }, 500);
      }
    });

    $(".hamburgerMenu").click(function (event) {
      $(".main__menu--bottom").css("right", "0");
    });
    $(".closeMenu").click(function (event) {
      $(".main__menu--bottom").css("right", "100%");
    });

    //DROPDOWN STYLE
    $("select").each(function () {
      if ($(this) != $("#monthsSelector")) {
        if (!$(this).parent().hasClass("dropdown")) {
          $("select:not(.nice-select-disabled)").niceSelect();
        }
      }
    });

    $("#primary-nav li").click(function (e) {
      $("#primary-nav li a").removeClass("active");

      if ($(this).children("ul").length > 0) {
        e.preventDefault();
        let submenu = $(this).find(".submenu");

        $("#header .menu-images .image__container").removeClass("active");
        $("#header.scroll-down .header__bottom").removeClass("active");
        $("#header .header__bottom .menu-images, #primary-nav li ul").animate(
          {
            top: "-500",
            opacity: 0,
          },
          450
        );

        if (submenu.hasClass("active")) {
          submenu.removeClass("active");
          $("#header").removeClass("hover__effect");
        } else {
          $("#primary-nav ul.submenu").removeClass("active");
          $(this).find("a").first().addClass("active");
          submenu.addClass("active");
          $(this).addClass("index-" + $(this).index());
          console.log($(this).index());
          if(($(this).index()+1) >= 9){
            $(
              "#header .menu-images .image__container.index-" + ($(this).index())
            ).addClass("active");
          }else{
            $(
              "#header .menu-images .image__container.index-" + ($(this).index()+1)
            ).addClass("active");
          }
          if ($(this).index() == 1) {
            $("#header .menu-images .image__container.index-0").addClass(
              "active"
            );
            $("#header .menu-images .image__container.index-1").addClass(
              "active"
            );
          }
          $("#header .header__bottom .menu-images").animate(
            {
              top: "-16",
              opacity: 1,
            },
            450,
            function () {
              $(this).addClass("active");
            }
          );

          $(this)
            .children("ul")
            .animate(
              {
                top: "115",
                opacity: 1,
              },
              450,
              function () {
                $(this).addClass("active");
                $("#header").addClass("hover__effect");
                $("#header.scroll-down .header__bottom").addClass("active");
              }
            );
        }
      }
    });

    $("#primary-nav li ul li").click(function () {
      window.location = $(this).find("a").attr("href");
      setTimeout(() => {
        $("#header .header__bottom").css("box-shadow", "none");
        $("#header .header__bottom .menu-images, #primary-nav li ul").css(
          "display",
          "none"
        );
      }, 400);
    });

    $("#content").on("click", function (e) {
      if (
        document.getElementById("header").contains(e.target) ||
        $(e.target).hasClass("next") ||
        $(e.target).hasClass("prev")
      ) {
        // Clicked in box
        // $('.book-widget').addClass('book-widget--open');
      } else {
        $("#primary-nav li a").removeClass("active");
        $(this).find("a").first().addClass("active");
        $("#header .menu-images .image__container").removeClass("active");
        $("#header.scroll-down .header__bottom").removeClass("active");
        $("#header").removeClass("hover__effect");
        $("#header .header__bottom .menu-images, #primary-nav li ul").animate(
          {
            top: "-500",
            opacity: 0,
          },
          500
        );
      }
    });

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    var getHeight = function (el) {
      var el_style = window.getComputedStyle(el),
        el_display = el_style.display,
        el_position = el_style.position,
        el_visibility = el_style.visibility,
        el_max_height = el_style.maxHeight.replace("px", "").replace("%", ""),
        wanted_height = 0;
      // if its not hidden we just return normal height
      if (el_display !== "none" && el_max_height !== "0") {
        return el.offsetHeight;
      }
      // the element is hidden so:
      // making the el block so we can meassure its height but still be hidden
      el.style.position = "absolute";
      el.style.visibility = "hidden";
      el.style.display = "block";
      wanted_height = el.offsetHeight;
      // reverting to the original values
      el.style.display = el_display;
      el.style.position = el_position;
      el.style.visibility = el_visibility;
      return wanted_height;
    };

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 3);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    });
  });

  $(window).on('load', function(){
    $(".slider-tabs").slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: false,
      draggable: true,
    });
    $(".slider-container").slick({
      arrows: true,
      centerMode: true,
      slidesToShow: 1,
      centerPadding: '300px'
    });
    $(".slider-tabs").slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: false,
      draggable: true,
    });
  });
})();
function initSlider() {
  $(".allimages").slick({
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: false,
    draggable: true,
  });
  setTimeout(function () {
    // equalize({ reset: true });
  }, 500);
  var lazyImages = [].slice.call(
    document.querySelectorAll(".animate-fade") || []
  );
  var active = false;

  function _intersectionObserver() {
    if (!active) {
      active = true;
      // setTimeout(function () {
      lazyImages.forEach(function (image) {
        var imageBoundingClientRect = image.getBoundingClientRect();
        if (
          imageBoundingClientRect.top <= window.innerHeight &&
          imageBoundingClientRect.bottom >= 0
        ) {
          if (!image.classList.contains("animate-fade"))
            image.classList.contains("lazyinlinebg")
              ? (image.style.backgroundImage =
                  "url(" + image.dataset.srcset + ")")
              : (image.src = image.dataset.srcset);

          if (!image.classList.contains("animate-fade")) {
            image.classList.add("visible");
          } else {
            image.classList.add("fade-in");
          }
          lazyImages = lazyImages.filter(function (_image) {
            return image !== _image;
          });
        }

        if (lazyImages.length === 0) {
          document.removeEventListener("scroll", _intersectionObserver);
          window.removeEventListener("resize", _intersectionObserver);
          window.removeEventListener(
            "orientationchange",
            _intersectionObserver
          );
        }

        active = false;
      });
      // }, 0);
    }
  }

  if (lazyImages.length > 0) {
    document.addEventListener("scroll", _intersectionObserver);
    window.addEventListener("resize", _intersectionObserver);
    window.addEventListener("orientationchange", _intersectionObserver);
  }

  _intersectionObserver();
}
